
interface TornadoProperties {
    id: string;
    'datetime-start': string;
    'f-scale': number[];
    scale?: string;
    countries?: string[];
    states?: string[];
    'path-length'?: number;
    'path-width'?: number;
    injuries?: number;
    fatalities?: number;
    source?: (string | Record<string, string | null>)[];
    'time-accuracy'?: string;
    utc_check?: boolean;
    comments?: Record<string, string[]> | string;
}

// This type in the GeoJSON module is defined stupidly
interface FeatureCollection<F extends GeoJSON.Feature> extends GeoJSON.GeoJsonObject {
    type: 'FeatureCollection';
    features: Array<F>;
}

type GeoJSONGeometryNoCollections = GeoJSON.Point | GeoJSON.LineString;
type GeoJSONGeometryCollections = GeoJSON.GeometryCollection<GeoJSONGeometryNoCollections | GeoJSON.Polygon>;

// Full tornado properties, features, geojson objects
type TornadoPropertiesNoCollection = Omit<TornadoProperties, 'f-scale'> & {'f-scale': number};
type TornadoProperty = TornadoProperties[keyof TornadoProperties] | undefined;

type TornadoNoFeatureCollection = GeoJSON.Feature<GeoJSONGeometryNoCollections | GeoJSON.Polygon, TornadoPropertiesNoCollection>;
type TornadoFeatureCollection = GeoJSON.Feature<GeoJSONGeometryCollections, TornadoProperties>;

type Tornado = TornadoNoFeatureCollection | TornadoFeatureCollection;
type TornadoGeoJSON = FeatureCollection<Tornado>;

// Minified tornado properties, features, geojson objects
type TornadoPropertiesMin = Pick<TornadoProperties, 'id' | 'f-scale'>;
type TornadoPropertiesMinNoCollection = Omit<TornadoPropertiesMin, 'f-scale'> & {'f-scale': number};

type TornadoMinNoFeatureCollection = GeoJSON.Feature<GeoJSONGeometryNoCollections | GeoJSON.Polygon, TornadoPropertiesMinNoCollection>
type TornadoMinFeatureCollection = GeoJSON.Feature<GeoJSONGeometryCollections, TornadoPropertiesMin>;

type TornadoMin = TornadoMinNoFeatureCollection | TornadoMinFeatureCollection;
type TornadoGeoJSONMin = FeatureCollection<TornadoMin>;

const isTornadoFeatureCollection = (tgc: any) : tgc is TornadoFeatureCollection => {
    return 'geometry' in tgc && 'type' in tgc['geometry'] && tgc['geometry']['type'] == 'GeometryCollection';
}

export { isTornadoFeatureCollection };
export type {TornadoGeoJSON, TornadoGeoJSONMin, Tornado, TornadoMin, TornadoNoFeatureCollection, TornadoFeatureCollection,
             TornadoProperties, TornadoPropertiesMin, TornadoPropertiesNoCollection, TornadoProperty,
             GeoJSONGeometryNoCollections};